(function () {
  'use strict';
  var config = window.STMNBtbConfig;
  if (!config) return;
  var end = Date.parse(config.endsAt), originals = new Map(), scheduled = false;
  var selector = ['SBtgmG','S54wAW','WiS3NF','UBzdLY'].map(function (id) { return 'form[data-testid="klaviyo-form-'+id+'"]'; }).join(',');
  function active() { return config.active && Date.now() < end; }
  function replace(el, text, heading) {
    var desired = '<p class="'+(heading ? 'stmn-newsletter-heading' : 'stmn-newsletter-copy')+'">'+text+'</p>';
    if (el.innerHTML === desired) return;
    if (!originals.has(el)) originals.set(el,el.innerHTML);
    el.innerHTML = desired;
  }
  function apply() {
    scheduled = false;
    if (!active()) {
      originals.forEach(function (html,el) { if (el.isConnected) el.innerHTML = html; });
      originals.clear(); return;
    }
    originals.forEach(function (_,el) { if (!el.isConnected) originals.delete(el); });
    document.querySelectorAll(selector).forEach(function (form) {
      var english = form.dataset.testid === 'klaviyo-form-WiS3NF';
      var copy = english ? 'Subscribe to our newsletter and get 10% off to use from September 14, after BACKTOBOX.' : 'Iscriviti alla newsletter e ricevi il 10% di sconto da usare dal 14 settembre, dopo BACKTOBOX.';
      var rich = Array.from(form.querySelectorAll('.klaviyo-form-richtext'));
      rich.forEach(function (el) {
        var text = el.textContent.trim();
        if (!/10\s*%/.test(text) || /privacy|GDPR|acconsenti|personal data/i.test(text)) return;
        var heading = text.length < 70 && !/da usare|to use|Subito|acquisto|purchase/i.test(text);
        replace(el,heading ? (english ? 'YOUR 10% AFTER BACKTOBOX' : 'IL TUO 10% DOPO BACKTOBOX') : copy,heading);
      });
      var hasCopy = rich.some(function (el) { return el.textContent.includes(copy); });
      if (!hasCopy) {
        var intro = rich.find(function (el) { return /newsletter/i.test(el.textContent) && !/privacy|GDPR|acconsenti|personal data/i.test(el.textContent); });
        if (intro) replace(intro,copy,false);
      }
    });
  }
  function schedule() { if (!scheduled) { scheduled = true; queueMicrotask(apply); } }
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches?.(selector+',.klaviyo-form-richtext') || node.querySelector?.(selector+',.klaviyo-form-richtext') || node.closest?.('.klaviyo-form-richtext')); }); })) schedule();
  });
  function start() { observer.observe(document.body,{childList:true,subtree:true}); apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('visibilitychange',function () { if (!document.hidden) apply(); });
  window.addEventListener('klaviyoForms',schedule);
  var remaining = end-Date.now();
  if (remaining > 0 && remaining < 2147482647) setTimeout(apply,remaining+100);
})();
